import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api/program`;

// Get auth token from localStorage
const getAuthToken = () => localStorage.getItem('authToken');

// Create axios instance with auth header
const apiClient = axios.create({
  baseURL: API,
});

// Add auth token to requests
apiClient.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Program API
export const programAPI = {
  // Get available languages for 15-day program
  getLanguages: async () => {
    const response = await apiClient.get('/languages');
    return response.data;
  },

  // Get full curriculum for a language
  getCurriculum: async (language) => {
    const response = await apiClient.get(`/${language}/curriculum`);
    return response.data;
  },

  // Get specific day lesson
  getDayLesson: async (language, dayNumber) => {
    const response = await apiClient.get(`/${language}/day/${dayNumber}`);
    return response.data;
  },

  // Get user progress
  getProgress: async (language) => {
    const response = await apiClient.get(`/${language}/progress`);
    return response.data;
  },

  // Generate test (daily or final)
  generateTest: async (language, dayNumber = null, isFinal = false) => {
    const response = await apiClient.post(`/${language}/generate-test`, {
      language,
      day_number: dayNumber,
      is_final: isFinal
    });
    return response.data;
  },

  // Submit test answers
  submitTest: async (language, answers, dayNumber = null, isFinal = false) => {
    const response = await apiClient.post(`/${language}/submit-test`, {
      language,
      day_number: dayNumber,
      is_final: isFinal,
      answers
    });
    return response.data;
  },

  // ==================== Leaderboard APIs ====================
  
  // Get global leaderboard
  getGlobalLeaderboard: async (limit = 20) => {
    const response = await apiClient.get(`/leaderboard/global?limit=${limit}`);
    return response.data;
  },

  // Get language-specific leaderboard
  getLanguageLeaderboard: async (language, limit = 20) => {
    const response = await apiClient.get(`/leaderboard/${language}?limit=${limit}`);
    return response.data;
  },

  // Get current user's rank
  getUserRank: async (language = null) => {
    const url = language 
      ? `/leaderboard/user/rank?language=${language}`
      : '/leaderboard/user/rank';
    const response = await apiClient.get(url);
    return response.data;
  },

  // ==================== Notifications APIs ====================
  
  // Get user notifications/reminders
  getNotifications: async () => {
    const response = await apiClient.get('/notifications');
    return response.data;
  },

  // Update streak after completing a lesson
  updateStreak: async (language) => {
    const response = await apiClient.post(`/${language}/update-streak`);
    return response.data;
  }
};

export default programAPI;
